import { Cached, CheckCircleOutline, ErrorOutline } from '@mui/icons-material'
import { styled } from '@mui/material'
import { JobStatusType } from '../types'

const SpinningCachedIcon = styled(Cached)(() => ({
  animation: 'spin 1000ms linear infinite',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(360deg)'
    },
    '100%': {
      transform: 'rotate(0deg)'
    }
  }
}))

const inProgressIcon = <SpinningCachedIcon data-testid="running" color="inherit" />
const okIcon = <CheckCircleOutline data-testid="success" />
const failedIcon = <ErrorOutline data-testid="failure" />

function JobsStatusIcon({ status }: { status?: JobStatusType | null }) {
  if (status === JobStatusType.Success) {
    return okIcon
  }
  if (status === JobStatusType.Failure) {
    return failedIcon
  }
  return inProgressIcon
}

export default JobsStatusIcon
